const BADGE_TONES = {
  neutral:
    "border-slate-300 bg-slate-100 text-slate-800 dark:border-slate-700/60 dark:bg-slate-900/40 dark:text-slate-200",
  red: "border-red-300 bg-red-100 text-red-900 dark:border-red-800/60 dark:bg-red-950/40 dark:text-red-200",
  amber:
    "border-amber-300 bg-amber-100 text-amber-900 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-200",
  emerald:
    "border-emerald-300 bg-emerald-100 text-emerald-900 dark:border-emerald-800/60 dark:bg-emerald-950/40 dark:text-emerald-200",
  sky: "border-sky-300 bg-sky-100 text-sky-900 dark:border-sky-800/60 dark:bg-sky-950/40 dark:text-sky-200",
  cyan: "border-cyan-300 bg-cyan-100 text-cyan-900 dark:border-cyan-800/60 dark:bg-cyan-950/40 dark:text-cyan-200",
  violet:
    "border-violet-300 bg-violet-100 text-violet-900 dark:border-violet-800/60 dark:bg-violet-950/40 dark:text-violet-200",
  indigo:
    "border-indigo-300 bg-indigo-100 text-indigo-900 dark:border-indigo-800/60 dark:bg-indigo-950/40 dark:text-indigo-200",
} as const;

const SALES_REP_TONE_BY_NAME: Record<string, keyof typeof BADGE_TONES> = {
  "needs someone": "red",
  unassigned: "neutral",
  jon: "sky",
  daniel: "emerald",
  brian: "violet",
  "vincent rodriguez": "indigo",
  "christopher oppenhuis": "amber",
};

const SALES_REP_FALLBACK_TONES = [
  BADGE_TONES.sky,
  BADGE_TONES.cyan,
  BADGE_TONES.violet,
  BADGE_TONES.amber,
  BADGE_TONES.emerald,
  BADGE_TONES.indigo,
] as const;

function normalizeLabel(value: unknown): string {
  if (typeof value !== "string") return "";
  return value
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");
}

function pickHashedTone(value: string, tones: readonly string[]): string {
  if (!value) return tones[0]!;
  let hash = 0;
  for (const char of value) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  }
  return tones[hash % tones.length]!;
}

export function getSalesRepBadgeClass(repName: unknown): string {
  const normalizedName = normalizeLabel(repName);
  if (!normalizedName) return BADGE_TONES.neutral;

  const mappedTone = SALES_REP_TONE_BY_NAME[normalizedName];
  if (mappedTone) return BADGE_TONES[mappedTone];

  return pickHashedTone(normalizedName, SALES_REP_FALLBACK_TONES);
}
